import {NgModule} from '@angular/core';
import {BmModule} from "./bm/bm.module";
import {BdModule} from "./bd/bd.module";


@NgModule({
    exports: [
        BmModule,
        BdModule
    ],
    imports: [

    ]
})
export class FeatureBmModule {
}